import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class ColumnBox extends Div
{
    constructor(...content: appendable[])
    {
        super("");

        this.Style("display: flex; flex-direction: column; justify-content: space-between; gap: 12px");
        this.Append(...content);
    }
}
